<script setup lang="ts">
import { computed, type Component } from 'vue';
import type { Video } from "@pkg/sanity-utils/types/video"

const props = defineProps<{
  block?: {
    _type: string,
    _key: string
    video?: Video
  },
  config: {
    innerComponent?: Component
  },
}>();

const data = computed(() => ({
  url: props.block?.video?.url,
  webm: props.block?.video?.webm,
  ogg: props.block?.video?.ogg,
  title: props.block?.video?.alt,
  controls: props.block?.video?.controls,
  autoplay: props.block?.video?.autoplay,
  videoType: props.block?.video?.videoType
}));

</script>

<template>
    <component :is="props.config?.innerComponent" v-bind="data" />
</template>